import * as React from 'react';
import FormGroup from 'myshubhlife-component/form/form-group';
import 'myshubhlife-component/form/styles.scss';
import Button from 'myshubhlife-component/button';
import {IFormGroupProps, IFormFieldGroup} from 'myshubhlife-component/form/FormInterfaceProps';

function Form (props: IFormGroupProps) {
  const handleSubmit = (e) => {
    e.prevent.default();
  }
  const handleFormChange = (index: number, value: string | number | string[] | boolean, formindex: number, fieldname: string) => {
    props.onFormChange(index, value, formindex, fieldname);
  }
  const validateForm = () => {
    let validated = true
    props.formData['fields'].map((field, fieldIndex) => {
      field['fields'].map((formfield, formfieldIndex) => {
        if (formfield.errorMsg) {
          validated = false;
        } else {
          if ((!formfield.value || (typeof (formfield.value) === 'string' && !formfield.value.length)) && formfield.value !== 0 && formfield.isRequired !== false && formfield.isReadOnly !== true && formfield.isDisabled !== true && formfield.type !== 'otp' && formfield.type !== 'file') {
            props.onFormChange(formfieldIndex, 'This field is required', fieldIndex, 'errorMsg');
            validated = false;
          } else if (formfield.type === 'otp') {
            if (!formfield.otp.length || formfield.otp.filter(item => item).length < formfield.otpLength) {
              props.onFormChange(formfieldIndex, 'Please Enter Otp', fieldIndex, 'errorMsg');
              validated = false;
            }
          } else if (formfield.type === 'file') {
            if (!formfield.value) {
              props.onFormChange(formfieldIndex, 'Please upload document', fieldIndex, 'errorMsg');
              validated = false;
            }
          }
        }
      })
    })
    return validated;
  }
  const handleClick = () => {
    if (validateForm()) {
      props.onFormSubmit();
    }
  }
    return (
    <div className="form-group">
    {
      props.formData['fields'].map((field, index) => {
        const formfield: IFormFieldGroup = field;
        return (
            <form className="s-form" key={formfield.identifier} onSubmit={handleSubmit}>
              <FormGroup formfields={formfield} formindex={index} inputStyleType={props.formData.inputStyleType} selectStyleType={props.formData.selectStyleType} key={`${formfield.identifier}${index}`} handleFormChange={handleFormChange}/>
            </form>
        )
      })
    }
    <Button size="large" buttonText={props.formData && props.formData.buttonlabel ? props.formData.buttonlabel: 'SUBMIT'} onClick={handleClick}/>
    </div>
  );
}

export default Form;
